import { keepPreviousData } from '@tanstack/react-query'
import { uniqBy } from 'lodash'
import { useEffect, useState } from 'react'

import { MarketOrderDtoCursorPaginatedResponse, useGetAllClientMarketOrders } from '@/gen/publicApi'

export default function useGetAllClientMarketOrdersInfinite(
    clientCode: string,
    marketCode: string,
    instrumentSymbol?: string,
) {
    const [cursor, setCursor] = useState<string | undefined>(undefined)
    const [pages, setPages] = useState<MarketOrderDtoCursorPaginatedResponse['data']>([])
    const [nextCursor, setNextCursor] = useState<string | undefined>(undefined)
    const { data, isLoading, refetch } = useGetAllClientMarketOrders(
        clientCode,
        marketCode,
        {
            Cursor: cursor,
            Limit: 500,
            instrumentSymbol,
        },
        {
            query: {
                placeholderData: keepPreviousData,
                refetchInterval: 1000,
            },
        },
    )

    useEffect(() => {
        if (!data) {
            return
        }

        setNextCursor(data?.nextCursor || undefined)

        const newData = pages?.concat(data.data || [])
        // I'm unsure what "uniqueness" means here so cobbling things together
        const newPages = uniqBy(newData, page => `${page.clientOrderRef}-${page.instrumentSymbol}-${page.marketRef}`)
        setPages(newPages)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    const fetchNextPage = () => {
        if (!nextCursor) {
            return
        }

        setCursor(nextCursor)
    }

    return {
        data: pages,
        isLoading,
        fetchNextPage,
        hasNextPage: nextCursor !== undefined,
        refetch,
    }
}
